<template>
  <div class="box profile-card-2">
    <div class="row">
      <div class="col-6" style="text-align: left">
        <span class="start_up_label">industries</span>
      </div>
      <div
        class="col-6"
        style="text-align: right"
        data-bs-toggle="modal"
        data-bs-target="#editIndustry"
      >
        <span class="start_up_edit">Edit</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="row investor_list">
          <div
            class="investor_data"
            v-for="(data, i) in form.industry"
            :key="i"
          >
           <!--  {{ data }} -->
            {{ getIndustryNameFromCode(data) }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="editIndustry"
      tabindex="-1"
      aria-labelledby="editIndustryLabel"
      aria-hidden="true"
      style=""
    >
      <div class="modal-dialog" style="width: 550px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Industry</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit="updateIndustry">
            <div class="modal-body" style="padding: 30px; padding-top: 50px">
              <div class="form-grouped">
                <div class="list-wrapper" v-if="isLoadingIndustry == true">
                  <img
                    src="/img/lightbox/preloader.gif"
                    style="margin-left: 10px"
                    class="button-spinner"
                  />
                </div>
                <div class="list-wrapper" v-if="isLoadingIndustry == false">
                  <ChipButton
                    v-for="(item, index) in projectIndustriesData"
                    :key="index"
                    :text="item.name"
                    :dashedBorder="true"
                    :buttonIcon="'img/interests/' + item.img"
                    :selected="checkedSelectedItem(item.tag)"
                    v-on:click="handleSelectIndustry(item.tag)"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div
                v-if="isUpdateIndustry"
                style="right: 0%; right: 0; margin-top: 0%; text-align: center"
                id="loaderCal"
              >
                <v-progress-circular
                  :size="30"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                {{ "updating industry..." }}
              </div>

              <button
                v-if="!isUpdateIndustry"
                type="button"
                class="btn btn-light lightBorder p-3"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                v-if="!isUpdateIndustry"
                type="submit"
                class="btn btn-primary p-3"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="errorModalIndustry"
      tabindex="-1"
      aria-labelledby="errorModalIndustryLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ERROR DETECTED</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/cancel.png"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">
              Error detected while updating industry
            </p>
            <code>{{ this.InndustryInfoUpdateError }}</code>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light lightBorder"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="successChangeRequestModalIndustry"
      tabindex="-1"
      aria-labelledby="successChangeRequestModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Industry Updated</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/marked.svg"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">Industry record updated successfully</p>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-light lightBorder"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateIndustry } from "@/api/client";
import ChipButton from "@/components/chipButton/chipButton";

import { mapActions } from "vuex";
import { getIndustry } from "@/api/client";
import { getPlatform, getRoles } from "@/api/client";

export default {
  props: ["form", "project_id"],
  data: () => ({
    InndustryInfoUpdateError: "",
    projectIndustriesData: [],
    isLoadingIndustry: false,
    isUpdateIndustry: false,
  }),
  components: {
    ChipButton,
  },
  created() {
    getIndustry()
      .then((data) => {
        let response = data.data.data;
        this.isLoadingIndustry = false;

        for (var i = 0; i < response.length; i++) {
          this.projectIndustriesData.push({
            name: response[i].industry_name,
            tag: response[i].industry_code,
            img: response[i].industry_svg,
          });
        }
      })
      .catch((error) => {
        this.isLoadingIndustry = false;
      });
  },

  computed: {
    checkedSelectedItem() {
      return (value, type) => {
        let selected = this.form.industry;
        const foundItem = selected.find((item) => item == value);
        return foundItem ? true : false;
      };
    },
  },
  mounted() {
    // console.log("form:: ", this.form.industry);
    // console.log("all:: ", this.projectIndustriesData);
  },
  methods: {
    ...mapActions("clientDashboard", ["updateProject"]),
    getIndustryNameFromCode(code) {
      let iName = (this.projectIndustriesData || []).find(
        (item) => item.tag == code
      );
      return "name" in iName ? iName.name : "None";
    },
    handleSelectIndustry(value) {
      let selected = this.form.industry;
      const currentValue = selected.find((item) => item == value);
      if (!currentValue) {
        this.form.industry.push(value);
      } else {
        this.form.industry = selected.filter((item) => item !== value);
      }
      this.form_errors.industry = [];
    },
    async updateIndustry(event) {
      event.preventDefault();

      const payload = {
        project_id: this.project_id,

        industry: this.form.industry,
      };

      this.isUpdateIndustry = true;

      await updateIndustry(payload)
        .then(async (response) => {
          this.isUpdateIndustry = false;
          $("#editIndustry").modal("hide");

          const { project } = response.data.data;

          if (response.data.status == 1) {
            this.updateProject(project);

            $("#successChangeRequestModalIndustry").modal("show");

            //
          } else {
            this.InndustryInfoUpdateError = response.data.errors;
            $("#errorModalIndustry").modal("show");
          }
        })
        .catch((error) => {
          $("#editIndustry").modal("hide");
          this.isUpdateIndustry = false;
          if (error.hasOwnProperty("message")) {
            this.InndustryInfoUpdateError = error.message;
          } else {
            this.InndustryInfoUpdateError = error.data.errors;
          }

          $("#errorModalIndustry").modal("show");
        });

      //console.log(payload);
    },
  },
};
</script>

<style scoped>
.lightBorder {
  border: 1px solid #eee;
}
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.modal_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  /* identical to box height, or 20px */

  display: flex;
  align-items: center;

  /* primary/700 (text) */

  color: #1b1e22;
  padding-bottom: 10px;
}

.profile-card-2 {
  text-align: left;
  background: #ffffff;

  border-bottom: 1px solid #eee;
  padding: 20px;
}
.start_up_line {
  border: 0.5px solid #e4e5e7;
}

.start_up_data {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  padding-top: 30px;
  padding-bottom: 20px;

  color: #1b1e22;
}
.start_up_edit {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;

  text-align: right;
  cursor: pointer;
  color: #0781f2;
}
.start_up_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;

  text-transform: uppercase;

  color: #979da5;
}

.investor_data {
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: auto;

  height: 31px;

  /* primary/0 */

  background: #ffffff;
  /* primary/100 */

  border: 1px solid #e4e5e7;
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.investor_list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  padding-top: 20px;
}

div.title {
  text-align: left;
  padding-top: 56px;
  padding-left: 5px;
  font-size: 23px;
  font-weight: bold;
}
.form-container {
  width: 588px;
  padding-top: 20px;
}
.div-label {
  text-align: left;
  font-size: 14px;
  padding-bottom: 5px;
  font-size: 14px;
  line-height: 145%;
}
.form-control {
  border: 1px solid #e4e5e7;
}
.form-control {
  margin-top: 4px;
  margin-bottom: 0px;
}
.form-grouped {
  margin-top: 0px;
}

.form_errors {
  color: red;
}
.check-product-name {
  text-align: left;
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #1b1e22;
  margin-top: 8px;
}
.light-label {
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #979da5;
  margin-top: 8px;
  text-align: left;
}
.chip-btn-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.button-container {
  /*display: flex;*/
  justify-content: flex-end;
  margin: 48px 0px;
  float: left;
}
.text-box-hint {
  font-size: 14px;
  line-height: 130%;
  color: #979da5;
  text-align: left;
  margin-top: 8px;
}
.medium-combo-box .v-text-field {
  border: 1px solid #e4e5e7;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 130%;
}

.textbox-wrapper {
  display: flex;
}
.textbox-wrapper div {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  /* background-color: #fff; */
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 0;
  width: 42px;
  background: black;
  color: white;
  height: 51px;
}
.light-text-label {
  color: #979da5;
}
.display-inline {
  display: inline-block;
  /* padding-top: 50px; */
}
.list-wrapper {
  display: flex;
  margin-top: 5px;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
}
.label-description {
  color: #979da5;
}
.brief_counter {
  margin-bottom: 28px;
}
@media (max-width: 768px) {
  .form-container {
    width: 100%;
  }
  .button-container {
    float: none;
  }
  .grupa-blue-btn {
    width: 100%;
  }
  .list-wrapper {
    width: 100%;
  }
  div.title {
    padding-top: 32px;
  }
  .chip-btn-container {
    width: 100%;
  }
  .form-grouped {
    margin-top: 32px;
  }
}
</style>
